import { Stack } from '@mantine/core';
import { Outlet, useNavigate, useSearch } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useCurrentUser } from '@feature/security';

export function AuthorResearchPerfEvalHeader() {
  const { id } = useCurrentUser();
  const userId = useSearch({
    from: '/_auth/research-perf-eval/_layout/$evaluationId/_layout',
    select: search => search.userId,
  });

  const navigate = useNavigate();
  useEffect(() => {
    if (userId == null) {
      navigate({
        to: '.',
        search: { userId: id },
      });
    }
  }, [navigate, id, userId]);

  return <Stack>{userId != null && <Outlet />}</Stack>;
}
